/*@flow*/
import * as I from 'immutable';
import type { StateT } from './types';
import defaultPanels from 'comps/District/defaultPanels';

const initState: StateT = {
  id: '',
  panelName: '',
  resourceName: 'dashboards',
  showBoundary: true,
  showDrawingTool: true,
  showPanelsControl: false,
  showLayersControl: true,
  showShapes: false,
  showImagesInListView: false,
  dataPanels: [],
  toolbarButtons: defaultPanels,
};

const mkState: I.RecordFactory<StateT> = I.Record(initState, 'State');
export default mkState;
